import EntityLogo from 'components/EntityLogo';
import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';

const DisciplinaryPlayer = () => {
  const entities = useEntities();

  // Columns relevant for player's disciplinaries
  const showColumns = [
    'Date',
    // 'Competition',
    'Game',
    { column: 'subject', width: 250 },
    'Status',
    'result',
  ];

  return (
    <HmsEntityTableController
      entity={entities.Disciplinary}
      exportEnabled={false}
      columnSelectorEnabled={false}
      filterEnabled={false}
      showColumns={showColumns}
      renderMobileRow={(record) => (
        <div>
          <div className="border-b-[1px] border-gray-100 px-4 py-4 flex rounded-t-md" style={{ background: 'linear-gradient(90deg, #f2f2f2 0%, #fafafa 2%, #fafafa 98%, #f2f2f2 100%)' }}>
            <div className="flex flex-col gap-[1px]">
              <span className="flex items-center gap-3">
                <EntityLogo entity={record.Competition} size={24} />
                <span className="font-bold text-[0.9rem]">{record?.subject}</span>
              </span>
              {/* <span className="text-gray-400 text-[0.8rem]">{record?.Competition?.name}</span> */}
            </div>
          </div>
          <div className="px-6 py-4 flex items-center rounded-b-md" style={{ background: 'linear-gradient(90deg, #f8f8f8 0%, #fff 2%, #fff 98%, #f8f8f8 100%)' }}>
            <div className="w-full grid grid-cols-4 gap-y-2">
              <span className="text-gray-500">Date:</span>
              <span className="col-span-3">{record?.date}</span>
              <span className="text-gray-500">Game:</span>
              <span className="col-span-3">{record?.Game ? `${record.Game.HomeTeam?.short} vs ${record.Game.AwayTeam?.short}` : '-'}</span>
              <span className="text-gray-500">Status:</span>
              <span className="col-span-3">{record?.status}</span>
              <span className="text-gray-500">Result:</span>
              <span className="col-span-3">{record?.result}</span>
            </div>
          </div>
        </div>
      )}
      canCreate={false}
      onRowClickLink={() => null}

    />
  )
}

export default DisciplinaryPlayer 